module.exports = __webpack_public_path__ + "img/personal_resources_transcode_fail.aa83aa8d.svg";